{
    "v": "5.9.0",
    "fr": 25,
    "ip": 0,
    "op": 62,
    "w": 500,
    "h": 500,
    "nm": "02 copy",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 12,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 0,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Deslizador",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 0,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 0,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.20000000298, 0.800000011921, 0.800000011921, 1], "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 62,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Line 1",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 136.839, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [116.632, 8.375]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.283], "y": [1.042] },
                                "o": { "x": [0.66], "y": [0.003] },
                                "t": 23,
                                "s": [0]
                            },
                            { "t": 46, "s": [100] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.292], "y": [1.008] },
                                "o": { "x": [0.447], "y": [0.013] },
                                "t": 9,
                                "s": [0]
                            },
                            { "t": 37, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 13,
            "op": 42,
            "st": -9,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Line 2",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 184.339, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [116.632, 8.375]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.283], "y": [1.037] },
                                "o": { "x": [0.66], "y": [0.003] },
                                "t": 27,
                                "s": [0]
                            },
                            { "t": 47, "s": [100] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.292], "y": [1.007] },
                                "o": { "x": [0.447], "y": [0.01] },
                                "t": 13,
                                "s": [0]
                            },
                            { "t": 35, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 16,
            "op": 43,
            "st": -5,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Line 3",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 184.339, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [116.632, 8.375]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.20000001496, 0.800000059838, 0.800000059838, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": { "a": 0, "k": 100, "ix": 2 },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": -9,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Line 4",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 232.339, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [116.632, 8.375]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": { "a": 0, "k": 100, "ix": 2 },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": -5,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "Line 5",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 280.839, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [68.632, 8.373]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.283], "y": [1.031] },
                                "o": { "x": [0.66], "y": [0.002] },
                                "t": 30,
                                "s": [0]
                            },
                            { "t": 47, "s": [100] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.292], "y": [1.007] },
                                "o": { "x": [0.447], "y": [0.01] },
                                "t": 16,
                                "s": [0]
                            },
                            { "t": 38, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 19,
            "op": 44,
            "st": -2,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Line 6",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.654, 280.839, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [62.347, 8, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [9.307, 8.318],
                                        [68.632, 8.373]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.20000001496, 0.800000059838, 0.800000059838, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": { "a": 0, "k": 0, "ix": 1 },
                    "e": { "a": 0, "k": 100, "ix": 2 },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Recortar trazados 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": -8,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "Fold",
            "parent": 9,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 18,
                            "s": [100]
                        },
                        { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 19, "s": [0] },
                        { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 40, "s": [0] },
                        { "t": 40.375, "s": [100] }
                    ],
                    "ix": 11
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 8,
                            "s": [82.029, 82.005, 0],
                            "to": [-11.333, -13.167, 0],
                            "ti": [11.333, 13.167, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 0.2 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 28,
                            "s": [14.029, 3.005, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.167, "y": 0 },
                            "t": 38,
                            "s": [14.029, 3.005, 0],
                            "to": [11.333, 13.167, 0],
                            "ti": [-11.333, -13.167, 0]
                        },
                        { "t": 56, "s": [82.029, 82.005, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [82.27, 82.27, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 8,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-42.27, 42.27],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [42.27, -42.27]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 13,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-35.651, 42.417],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [41.679, -33.508]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 14,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-31.152, 42.4],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [42.262, -28.889]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 18,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [10.413, 42.206],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [42.099, 16.778]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [14.73, 42.714],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [42.099, 17.73]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 44,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-15.705, 42.846],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [41.974, -11.231]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-22.044, 42.873],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [41.626, -17.202]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-38.103, 42.318],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [41.692, -36.325]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 56,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-42.27, 42.27],
                                                    [18.115, 42.27],
                                                    [42.27, 18.116],
                                                    [42.374, -39.731]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [82.27, 82.27], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [98.446, 98.446], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "Paper Up",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 6,
                            "s": [25.846, 25.846, 0],
                            "to": [3.333, 3.667, 0],
                            "ti": [-3.333, -3.667, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 0.2 },
                            "o": { "x": 0.6, "y": 0.6 },
                            "t": 25,
                            "s": [45.846, 47.846, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 39,
                            "s": [45.846, 47.846, 0],
                            "to": [-3.333, -3.667, 0],
                            "ti": [3.333, 3.667, 0]
                        },
                        { "t": 56, "s": [25.846, 25.846, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [154.732, 197.003, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 8,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-12.779, 12.801],
                                                    [-4.483, 4.513],
                                                    [0.212, -0.172],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.145, 0.26],
                                                    [4.215, -4.222],
                                                    [18.167, -18.292],
                                                    [-0.424, 0.343],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-91.521, -107.255],
                                                    [-78.337, -120.498],
                                                    [-42.27, -157.002],
                                                    [90.577, -157.002],
                                                    [114.732, -132.847],
                                                    [114.732, 132.848],
                                                    [90.577, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 14,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-9.025, 13.032],
                                                    [-6.048, 3.959],
                                                    [-6.077, -0.185],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.038, -6.615],
                                                    [4.836, -7.379],
                                                    [16.704, -12.977],
                                                    [15.024, 0.289],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-103.254, -110.036],
                                                    [-77.056, -138.51],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 17,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-2.997, 13.402],
                                                    [-8.56, 3.069],
                                                    [-16.176, -0.206],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.134, -17.654],
                                                    [5.834, -12.449],
                                                    [14.353, -4.444],
                                                    [39.828, 0.203],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-110.368, -127.529],
                                                    [-86.724, -151.796],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 21,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-0.236, 15.241],
                                                    [-13.223, 1.537],
                                                    [-18.765, -0.211],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.178, -20.484],
                                                    [2.891, -14.499],
                                                    [15.932, -0.02],
                                                    [46.187, 0.18],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-114.702, -130.588],
                                                    [-88.87, -156.827],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 26,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [0.185, 13.598],
                                                    [-18.162, -0.086],
                                                    [-21.507, -0.217],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.224, -23.481],
                                                    [-0.227, -16.67],
                                                    [13.112, 0.062],
                                                    [52.924, 0.157],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-114.675, -128.549],
                                                    [-87.615, -156.759],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.6, "y": 0 },
                                        "t": 35,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [0.185, 13.598],
                                                    [-18.162, -0.086],
                                                    [-21.507, -0.217],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.224, -23.481],
                                                    [-0.227, -16.67],
                                                    [13.112, 0.062],
                                                    [52.924, 0.157],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-114.675, -128.549],
                                                    [-87.615, -156.759],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [0.105, 16.068],
                                                    [-12.145, 1.891],
                                                    [-18.166, -0.21],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.167, -19.829],
                                                    [1.105, -15.432],
                                                    [18.432, -0.187],
                                                    [44.717, 0.185],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -82.04],
                                                    [-114.663, -130.496],
                                                    [-87.49, -156.742],
                                                    [-42.27, -157.002],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 43,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-0.516, 1.562],
                                                    [-1.63, 1.283],
                                                    [-2.021, 0.44],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.506, -12.628],
                                                    [-1.016, 1.562],
                                                    [6.37, -0.717],
                                                    [40.331, 0.201],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.629, -88.373],
                                                    [-113.608, -114.064],
                                                    [-68.493, -155.284],
                                                    [-47.103, -156.941],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 44,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [0.913, -0.288],
                                                    [-5.099, 4.48],
                                                    [-0.66, 0.033],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.43, -6.39],
                                                    [4.456, -4.215],
                                                    [1.608, 0.157],
                                                    [35.946, 0.216],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.526, -95.206],
                                                    [-114.552, -108.631],
                                                    [-63.247, -156.576],
                                                    [-51.936, -156.879],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-7.571, 8.507],
                                                    [-8.567, 7.677],
                                                    [0.701, -0.373],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.354, -0.151],
                                                    [9.929, -9.993],
                                                    [11.933, -9.823],
                                                    [31.56, 0.231],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.422, -101.04],
                                                    [-99.497, -117.198],
                                                    [-74.001, -141.867],
                                                    [-56.77, -156.817],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.2, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 47,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-12.354, 12.901],
                                                    [-9.553, 8.875],
                                                    [-0.339, -0.761],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [-0.519, -1.095],
                                                    [13.646, -13.599],
                                                    [11.947, -11.125],
                                                    [15.024, 0.289],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.589, -90.04],
                                                    [-97.254, -111.036],
                                                    [-68.556, -140.51],
                                                    [-48.27, -156.873],
                                                    [90.578, -157.002],
                                                    [114.733, -132.847],
                                                    [114.733, 132.848],
                                                    [90.578, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 52,
                                        "s": [
                                            {
                                                "i": [
                                                    [-0.613, 73.694],
                                                    [-12.779, 12.801],
                                                    [-4.483, 4.513],
                                                    [0.212, -0.172],
                                                    [0, 0],
                                                    [0, -13.339],
                                                    [0, 0],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339]
                                                ],
                                                "o": [
                                                    [0.145, 0.26],
                                                    [4.215, -4.222],
                                                    [18.167, -18.292],
                                                    [-0.424, 0.343],
                                                    [13.34, 0],
                                                    [0, 0],
                                                    [0, 13.339],
                                                    [0, 0],
                                                    [-13.339, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-114.732, -84.54],
                                                    [-91.521, -107.255],
                                                    [-78.337, -120.498],
                                                    [-42.27, -157.002],
                                                    [90.577, -157.002],
                                                    [114.732, -132.847],
                                                    [114.732, 132.848],
                                                    [90.577, 157.002],
                                                    [-90.578, 157.002],
                                                    [-114.732, 132.848]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [154.732, 197.003], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Mask Paper",
            "parent": 9,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [154.732, 197.003, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [154.732, 197.003, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, -13.339],
                                        [0, 0],
                                        [13.34, 0],
                                        [0, 0],
                                        [0, 13.339]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [13.34, 0],
                                        [0, 0],
                                        [0, 13.339],
                                        [0, 0],
                                        [-13.339, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-114.732, -84.54],
                                        [-42.27, -157.002],
                                        [90.578, -157.002],
                                        [114.733, -132.847],
                                        [114.733, 132.848],
                                        [90.578, 157.002],
                                        [-90.578, 157.002],
                                        [-114.732, 132.848]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": true
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [154.732, 197.003], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "fl",
                    "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "bm": 0,
                    "nm": "Relleno 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": -4,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "Paper Back",
            "parent": 1,
            "tt": 2,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 6,
                            "s": [74.154, 74.154, 0],
                            "to": [-4.667, -4.333, 0],
                            "ti": [4.667, 4.333, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 0.2 },
                            "o": { "x": 0.6, "y": 0.6 },
                            "t": 25,
                            "s": [46.154, 48.154, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.2, "y": 1 },
                            "o": { "x": 0.6, "y": 0 },
                            "t": 39,
                            "s": [46.154, 48.154, 0],
                            "to": [4.667, 4.333, 0],
                            "ti": [-4.667, -4.333, 0]
                        },
                        { "t": 57, "s": [74.154, 74.154, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [154.732, 197.002, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, -13.339],
                                        [0, 0],
                                        [13.339, 0],
                                        [0, 0],
                                        [4.529, 4.535],
                                        [0, 6.407],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [13.339, 0],
                                        [0, 0],
                                        [0, 13.339],
                                        [0, 0],
                                        [-6.407, 0],
                                        [-4.535, -4.529],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [66.424, -157.002],
                                        [90.578, -157.002],
                                        [114.732, -132.848],
                                        [114.732, 132.848],
                                        [90.578, 157.002],
                                        [-90.578, 157.002],
                                        [-107.655, 149.925],
                                        [-114.732, 132.848],
                                        [-114.732, 108.694]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Trazado 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": { "a": 0, "k": 16, "ix": 5 },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Trazo 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [154.732, 197.002], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transformar"
                        }
                    ],
                    "nm": "Grupo 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 62,
            "st": -4,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 12,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "hd": true,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 63,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
